<template>
  <v-dialog v-model="modalActivo" persistent max-width="480">
    <v-form ref="form1">
      <v-container grid-list-sm text-center>
        <v-card :color="$store.state.sysBackgroundColor">
          <v-card-title>
            <v-layout row wrap>
              <v-flex>
                <h3 class="overline">{{ titulo }}</h3>
                <p class="caption font-weight-light">{{ comprobante }}</p>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6 offset-xs6 md4 offset-md8>
                <Importe
                  refocus="controlFocoImporte"
                  label="Importe*"
                  :model="itemActivo.Importe"
                  :rules="[rules.requerido]"
                  @seleccionarItem="item => (itemActivo.Importe = item.Importe)"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text rounded @click="ejecutarAccion('Cerrar')">
              Cancelar
              <v-icon right>clear</v-icon>
            </v-btn>
            <v-btn
              small
              rounded
              color="primary"
              @click="ejecutarAccion('Aceptar')"
            >
              Aceptar
              <v-icon right>check</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-form>
  </v-dialog>
</template>

<script>
import { eventBus } from "@/main";
import Importe from "@/components/Importe";
export default {
  name: "ModalTipoPagoEfectivo",
  components: {
    Importe
  },
  props: {
    activo: Boolean,
    comprobante: String,
    importe: Number
  },
  data() {
    return {
      titulo: "Pago en Efectivo",
      itemVacio: {
        Importe: 0
      },
      itemActivo: {},
      modalActivo: false,
      rules: {
        requerido: v => !!v || "Requerido"
      }
    };
  },
  watch: {
    activo() {
      this.modalActivo = this.activo;
      if (this.activo) {
        this.itemActivo.Importe = this.importe;
        setTimeout(() => {
          eventBus.$emit("setearFocoImporte", "controlFocoImporte");
        }, 100);
      } else this.inicializar();
    }
  },
  created() {
    this.inicializar();
  },
  methods: {
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
    },
    ejecutarAccion(accion) {
      if (accion == "Aceptar") {
        if (this.$refs.form1.validate()) {
          this.$emit("ejecutarAccion", accion, this.itemActivo);
        }
      } else this.$emit("ejecutarAccion", accion, null);
    }
  }
};
</script>
